import { FirmSidebar } from "../components/FirmSidebar";
import { Outlet } from "react-router-dom";
import { useFirmContext } from "../context";
import { Container, Dialog } from "@mui/material";
import { UserProfileUpdate } from "../../users/components/UserProfileUpdate";
import { useUserContext } from "../../users/context";
import Intercom from "@intercom/messenger-js-sdk";
import { useEffect } from "react";
import { TransitionOverlay } from "../../../components/TransitionOverlay";


export const Firm = () => {

    const { firmContext } = useFirmContext();
    const { userContext, loadUserContext } = useUserContext();

    useEffect(() => {
        if (process.env.REACT_APP_INTERCOM_APP_ID) {
            Intercom({
                app_id: process.env.REACT_APP_INTERCOM_APP_ID,
                user_id: userContext.dbUser?.uuid,
                name: userContext.dbUser?.profile?.name,
                email: userContext.dbUser?.email_address,
                created_at: (new Date(userContext.dbUser?.created_at)).valueOf(), // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
            });
        }
    }, [userContext.dbUser]);

    if (!firmContext.fetched || !userContext.fetched) {
        return <TransitionOverlay open={true} message="Loading..." />;
    }

    return (
        <>
            <aside className="page-sidebar">
                <FirmSidebar />
            </aside>
            <Container component="main">
                <Outlet />
            </Container>
            {userContext.dbUser?.profile && !userContext.dbUser?.profile?.user_reviewed &&
                <Dialog open={true} onClose={() => {}}>
                    <h5>Welcome to the {firmContext.organization.name} Firm Network</h5>
                    <p>Please take a moment to review and update your profile.</p>
                    <UserProfileUpdate user={userContext.dbUser} onUpdate={loadUserContext} />
                </Dialog>
            }
        </>
    );
}